import React from 'react';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import Hidden from '@material-ui/core/Hidden';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardAvatar from 'components/Card/CardAvatar.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';
import config from 'config';

const socialMediaIcon = {
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  twitter: TwitterIcon,
};

export const PublicProfileDetails = ({
  name,
  userBio,
  isFollowed,
  profilePhoto,
  toggleFollow,
  socialAccounts,
}) => (
  <GridContainer
    style={{
      textAlign: 'left',
    }}
  >
    <GridItem xs={5} md={4} lg={3}>
      <CardAvatar
        profile
        style={{
          borderRadius: '50%',
          marginBottom: '20px',
          boxShadow: '0px 0px 10px -5px rgba(0,0,0,0.75)',
        }}
      >
        <img src={profilePhoto} alt='User Photo' />
      </CardAvatar>
    </GridItem>
    <GridItem xs={7} md={8} lg={9}>
      <CardBody
        profile
        style={{
          padding: '0',
          textAlign: 'left',
          marginLeft: '-25px',
        }}
      >
        <div
          style={{
            fontSize: '19px',
            fontWeight: 'bold',
            marginBottom: '5px',
          }}
        >
          {name}
        </div>
        {!!userBio && (
          <div
            style={{
              color: '#c8c8c8',
              fontSize: '19px',
              fontWeight: 'bold',
            }}
          >
            {userBio}
          </div>
        )}
        <GridContainer xs={12} style={{ marginTop: '10px' }}>
          {Object.keys(socialAccounts).map((e) => {
            const Icon = socialMediaIcon[e];
            return (
              socialAccounts[e] && (
                <GridItem xs={2} md={4} key={e}>
                  <a
                    target='_blank'
                    href={`${config.socialMediaUrls[e]}/${socialAccounts[e]}`}
                    title={socialAccounts[e]}
                  >
                    <Hidden smUp implementation='css'>
                    <Icon style={{ color: '#4799fc'}} />
                    </Hidden>
                    <Hidden xsDown implementation='css'>
                    <Icon style={{ color: '#4799fc'}} />
                      <span style={{ color: '#4799fc', fontWeight: 'bold', position: 'relative', bottom: '7px', left: '5px'}}>{socialAccounts[e]}</span> 
                    </Hidden>
                  </a>
                </GridItem>
              )
            );
          })}
        </GridContainer>
      </CardBody>
    </GridItem>
    <GridItem xs={12} style={{ textAlign: 'center' }}>
      <Button
        style={{
          width: '80%',
          border: isFollowed ? '2px solid #a683fc' : 'transparent',
          color: isFollowed ? '#a683fc' : '#FFFFFF',
          padding: '10px',
          background: isFollowed
            ? 'white'
            : 'linear-gradient(90deg, rgba(175,148,245,1) 0%, rgba(100,114,219,1) 100%)',
          borderRadius: '50px',
          boxShadow: isFollowed
            ? '0px 0px 10px -5px rgba(0,0,0,0.75)'
            : '0px 0px 15px -5px rgba(0,0,0,0.75)',
          fontWeight: '600',
          fontSize: '15px',
        }}
        onClick={toggleFollow}
      >
        {isFollowed ? 'Following' : `Follow ${name}`}
      </Button>
    </GridItem>
  </GridContainer>
);

export default withStyles(Style)(PublicProfileDetails);
